import { render, staticRenderFns } from "./page_common.vue?vue&type=template&id=c998eb24"
import script from "./page_common.vue?vue&type=script&lang=js"
export * from "./page_common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports